const paymentGateway = {
    FS: 0,
    CRYPTO: 1
}

export {
    paymentGateway
}